module.exports = "/_next/static/images/WomenInData-904fd210fa17bbd61675a1ec32f6b1b3.jpg";